import React from "react";
import { FaFilePdf } from "react-icons/fa6";

export default function Privacy({ termsAndConditionsData, privacyPolicyData }) {
  return (
    <>
      <div className="p-4 ">
        <div className="flex items-center justify-start gap-x-4 w-full">
          {termsAndConditionsData && (
            <div
              className="max-w-xl h-full border md:p-8 p-4 bg-white rounded-lg space-y-4cursor-pointer"
              onClick={() => {
                if (termsAndConditionsData) {
                  window.open(termsAndConditionsData, "_blank");
                }
              }}
            >
              <div className="md:px-2 md:py-2 px-1 py-1 text-md text-center text-red-500 hover:bg-opacity-90">
                <svg className="font-bold md:w-12 md:h-12 w-10 h-10" viewBox="0 0 16 16">
                  <FaFilePdf />
                </svg>
              </div>
              <p className="font-medium md:text-xl text-base text-gray-900 mt-1">
                Terms & Condition
              </p>
            </div>
          )}
         {
          privacyPolicyData && 
          <div className="max-w-xl h-full border md:p-8 p-4 bg-white rounded-lg cursor-pointer"
          onClick={() => {
            if (privacyPolicyData) {
              window.open(privacyPolicyData, "_blank");
            }
          }}
          >
            <div className="md:px-2 md:py-2 px-1 py-1 text-md text-center text-red-500 hover:bg-opacity-90 ">
              <svg className="font-bold md:w-12 md:h-12 w-10 h-10" viewBox="0 0 16 16">
                <FaFilePdf />
              </svg>
            </div>
            <p className="w-full font-medium md:text-xl text-base text-gray-900 mt-1">
              Privacy Policy
            </p>
          </div>}
        </div>
      </div>
    </>
  );
}
